export default __webpack_public_path__ + "static/media/12-small.59ec58ce.png";